import { render, staticRenderFns } from "./ActGuoQingBuoy.vue?vue&type=template&id=24be4700&scoped=true&"
import script from "./ActGuoQingBuoy.vue?vue&type=script&lang=js&"
export * from "./ActGuoQingBuoy.vue?vue&type=script&lang=js&"
import style0 from "./ActGuoQingBuoy.vue?vue&type=style&index=0&id=24be4700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24be4700",
  null
  
)

export default component.exports